// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'ai-assist';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.576 10.656v6.768m0-1.08h11.232a2.243 2.243 0 0 0-2.232-2.232H6.768a2.243 2.243 0 0 0-2.232-2.232H.576m3.888 2.232h2.232M3.528 1.728v3.024M2.016 3.24H5.04m9.936 7.776v3.024m-1.512-1.512h3.024' />
    <path
      fill='currentColor'
      d='M8.784 12.168c.216-.072.432-.072.72-.072s.576.072.792.144c1.08-2.448 3.312-3.672 6.696-3.672-5.184-.072-7.488-2.808-7.488-7.488 0 5.112-2.664 7.488-7.488 7.488 3.672-.072 5.832 1.296 6.768 3.6z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
